module.exports = __webpack_public_path__ + "static/img/H13_1.6dc50ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H13_1.png
// module id = Iq6k
// module chunks = 0